export default function useStateLogger(name, [value, setter]) {
    if (process.env.REACT_APP_FORMIO_DEBUG_LOGS)
        return [value, (x) => { console.debug(name, { ...x }); setter(x) }];
    return [value, setter];
}